import React, { useState, useEffect, createRef } from 'react';

import Button from 'react-bootstrap/Button';
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import fixtureService from '../../services/FixtureService';

import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';

const CreateTrainingFixturesModal = (props) => {
    const typeAheadRef = createRef();

    const {show, onHide, setNewTrainingFixtureAdded} = props;

    const [fixturesDropdownList, setFixturesDropdownList] = useState(null);
    const [trainingName, setTrainingName] = useState('');
    const [selectedFixture, setSelectedFixture] = useState(null);

    const [errorText, setErrorText] = useState('');

    let errorLabel = errorText && errorText.length > 0 ? <span className="text-danger">{errorText}</span> : <></>;

    useEffect(() => {
        if (!fixturesDropdownList) {
            fixtureService.getFixturesWithVideoDropdownList().then((response) => {
                setFixturesDropdownList(response);
            });
        }
    })

    const renderDropdown = (fixturesDropdown, setSelectedFixture) => {
        if (fixturesDropdown) {
            let typeAheadFixtures = fixturesDropdown.map((x) => {
                return {id: x.bureauId, label: x.title}
            });

            return <Typeahead
                id="my-typeahead-id"
                ref={typeAheadRef}
                clearButton
                onChange={(selected) => {
                    if (selected && selected.length > 0) {
                        setSelectedFixture(selected[0]);
                    } else {
                        setSelectedFixture(null);
                    }
                }}
                options={typeAheadFixtures}
                placeholder="Type to search fixtures"
            />
        }
        return <></>
    }

    let dropdown = renderDropdown(fixturesDropdownList, setSelectedFixture);

    return <Modal
        show={show}
        onHide={onHide}
        backdrop="static"
        centered
    >
        <Modal.Header closeButton>
            <Modal.Title>
                <h3>
                    Create Training Fixtures
                </h3>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Row className="mb-2">
                <Col>
                    <Form.Label htmlFor="trainingNameInput">Training Identifier</Form.Label>
                    <Form.Control
                        id="trainingNameInput"
                        type="text"
                        value={trainingName ? trainingName : ''}
                        onChange={(event) => {
                            setTrainingName(event.target.value);
                        }}
                        placeholder="Name"/>
                    <em>Give each Training Fixture a name to identify it from other Training Fixtures generated from the
                        same fixture</em>
                </Col>
            </Row>
            <Row className="mb-2">
                <Col>
                    <Form.Label htmlFor="">Video to clone</Form.Label>
                    {dropdown}
                    <em>Select fixture to clone video from</em>
                </Col>
            </Row>
            <Row>
                <Col>
                    {errorLabel}
                </Col>
            </Row>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="outline-success" onClick={async () => {
                setErrorText(null);
                try {
                    await fixtureService.createTrainingFixture(trainingName, selectedFixture.id);
                    setNewTrainingFixtureAdded(true);
                    setTrainingName('');
                    onHide(true)
                } catch (err) {
                    if (err && err.data && err.data.error) {
                        setErrorText(err.data.error)
                    } else {
                        setErrorText('An error occurred')
                    }
                }
            }}>Create</Button>
            <Button variant="outline-danger" onClick={() => {
                setErrorText(null);
                setTrainingName('');
                onHide(false, null);
            }}>Cancel</Button>
        </Modal.Footer>
    </Modal>;
}

export default CreateTrainingFixturesModal;